"use strict";
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unnecessary-type-constraint */
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Obj = void 0;
exports.Obj = Object.freeze({
    pick: function (base) {
        var keys = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            keys[_i - 1] = arguments[_i];
        }
        var entries = keys.map(function (key) { return ([key, base[key]]); });
        return Object.fromEntries(entries);
    },
    rename: function (base, key, to) {
        var _a;
        var result = Object.assign({}, (_a = {}, _a[to] = base[key], _a), Object.fromEntries(Object.entries(base).filter(function (x) { return x[0] !== key; })));
        return result;
    },
    sortKeys: function (obj) {
        return Object.fromEntries(Object.entries(obj).sort(function (_a, _b) {
            var _c = __read(_a, 1), a = _c[0];
            var _d = __read(_b, 1), b = _d[0];
            return a.localeCompare(b);
        }));
    },
});
